import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

/**
 * Checking for if Loom is disabled.
 * These are some SSR friendly checks that we can run before we even try to render
 * this entrypoint to try and prevent some page header shifting issues.
 */
export const useIsLoomDisabled = (): boolean => {
	const isMobile = isMobileUserAgent() || shouldShowMobileWeb();
	const isLoomFeatureEnabled = isFeatureEnabled('confluence', 'confluence-loom-integration');

	const { accessStatus, isLoggedIn } = useSessionData();
	const isLicensed =
		accessStatus == AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus == AccessStatus.LICENSED_USE_ACCESS;

	if (!isLoggedIn || !isLicensed) {
		return true;
	}

	// Disable when feature is not enabled in current environment/evaluation
	if (!isLoomFeatureEnabled) {
		return true;
	}

	// don't enable entry points if user is on a mobile device or viewing mobile web
	if (isMobile) {
		return true;
	}

	return false;
};
